import { useParams } from "react-router-dom";
import { ViewPost } from "../Components/Post";
import { usePost } from "../hooks/api/usePost";
import RightSidebar from "../Components/RightSidebar";



export default function PostPage() {
    const { postId } = useParams()
    const { data: Post } = usePost(postId)


    return (
        <div className="flex overflow-x-hidden 2xl:overflow-x-visible w-full bg-[#1C1B16]">
            <div
                className="w-full lg:w-2/3 flex flex-col items-center"
            >
                <div className="w-full py-4 max-w-[768px] flex flex-col gap-4 px-1 sm:px-6 lg:px-0 flex-shrink">
                    <ViewPost feed={Post} isPostPage />
                    {/* <div ref={sentinelRef} className="h-10" /> */}
                </div>
            </div>

            <div className="hidden lg:block fixed top-16 right-0 2xl:top-0 2xl:static w-1/4 2xl:w-1/3 shrink-0">
                <div className="2xl:sticky 2xl:top-16 w-full h-[calc(100vh-64px)] overflow-y-auto scrollbar-hide">
                    <RightSidebar />
                </div>
            </div>
        </div>
    )
}